import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Result, SuccessResult } from "@pages/editor/stores";

interface Props {
  result: Result;
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
`;

const ResultFragment = styled.span`
  :not(:first-child)::before {
    content: " · ";
  }
`;

const Summary = ({ result }: Props) => {
  const { matchesCount, errorsCount, testFailuresCount } = result;
  return (
    <>
      {errorsCount > 0 ? (
        <Container>
          <b>
            {errorsCount} {errorsCount === 1 ? "error" : "errors"}
          </b>
          <span>
            <FontAwesomeIcon icon={faTimesCircle} /> run failed
          </span>
        </Container>
      ) : (
        <Container>
          <b>
            {matchesCount} {matchesCount === 1 ? "match" : "matches"}
          </b>
          {result instanceof SuccessResult && (
            <div>
              <ResultFragment>
                took {result.runtimeSeconds.toFixed(1)}s
              </ResultFragment>
              <ResultFragment>
                {testFailuresCount === 0 ? (
                  <span style={{ color: "var(--green1)" }}>
                    <FontAwesomeIcon icon={faCheckCircle} /> tests passed
                  </span>
                ) : (
                  <span style={{ color: "var(--intent-danger)" }}>
                    <FontAwesomeIcon icon={faTimesCircle} /> {testFailuresCount}{" "}
                    {testFailuresCount === 1 ? "test" : "tests"} failed
                  </span>
                )}
              </ResultFragment>
            </div>
          )}
        </Container>
      )}
    </>
  );
};
export const ResultSummary = observer(Summary);
